export interface SearchVehiclesFilter {
  numberPlate?: string;
  vin?: string;
}

/** Body payload for the search vehicles request. */
export class SearchVehiclesRequestBody {
  resultPartition?: number;
  searchFilter: SearchVehiclesFilter;
}
